import React from "react";
import { useAppSelector } from "tsi-common-react/src/apps/reducers";
import { formatDistance } from "tsi-common-react/src/apps/retail/helpers";
import { t } from "ttag";

import { nearestFlagshipStoreSelector } from "../selectors";

export const DistanceToFlagshipStore = (): React.ReactNode => {
    const store = useAppSelector(nearestFlagshipStoreSelector);

    let text: string = t`See Closest Location`;
    if (store && store.distance) {
        const formattedDist = formatDistance(store.distance);
        text = t`${formattedDist} miles away`;
    }

    return <>{text}</>;
};
